import React from 'react'
import BucketHeader from '../../../DTO/BucketHeader'
import {BucketMemberId} from '../../../DTO/BucketMemberId'
import {PIMCard} from '../../Atoms/Cards/PIMCard'
import {SignedUpServiceListContent} from './SignedUpServiceListContent'
import {Spacer} from '../../../../Common/Components/Spacer'
import {PIMStack} from '../../Atoms/Layouts/Bases/PIMStack'
import {useTranslation} from 'react-i18next'

type RegisteredFreeServiceContentBlockProps = {
  freeServices: BucketHeader[],
  bucketMemberIdList: BucketMemberId[]
}
export const RegisteredFreeServiceContentBlock:
  React.VFC<RegisteredFreeServiceContentBlockProps> = (
  {
    freeServices,
    bucketMemberIdList,
  },
) => {
  const {t} = useTranslation('member')
  if (freeServices.length === 0 || bucketMemberIdList.length === 0) return null

  const signedUpFreeServiceList = getSignupFreeBucketList(freeServices, bucketMemberIdList)
  if (signedUpFreeServiceList.length === 0) return null

  return (
    <Spacer mb={'16px'}>
      <PIMStack alignItems={'center'}>
        <PIMCard
          headerProps={{title: t('新規登録完了.入会バケット情報.無料バケット情報.見出し')}}
          testId={'block-registered-free-services-content'}
          pb={'24px'}
        >
          <SignedUpServiceListContent
            signedUpBucketHeaderList={signedUpFreeServiceList}
            bucketMemberIdList={bucketMemberIdList}
            testId={'signed-up-free-service-list-content'}
          />
        </PIMCard>
      </PIMStack>
    </Spacer>)
}


export const getSignupFreeBucketList = (
  freeServices: BucketHeader[],
  bucketMemberIdList: BucketMemberId[],
): BucketHeader[] => {
  return freeServices.filter(bucketHeader =>
    bucketMemberIdList.find(bucketMemberId => bucketHeader.id === bucketMemberId.bucketId))
}
